/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/generate/GenerateNumberString.ts
 * @create:      2025-06-28 09:39:38.555
 * @modify:      2025-07-11 21:19:12.895
 * @version:     6.0.0
 * @times:       8
 * @lines:       60
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty } from "../const/Strings";
import { GenerateRandomInt } from "./GenerateRandomInt";

/**
 * Generates a random numeric string of the specified length.
 *
 * Each character in the resulting string is a digit between 0 and 9 (inclusive).
 *
 * @param length - The desired length of the generated numeric string.
 * @returns A string consisting of random digits with the specified length.
 * 
 * @version 1.0.0
 * @since 1.0.5
 */
export function GenerateNumberString(length: number) {
    let result: string = Strings_Empty;
    const max = 9;
    for (let i = 0; i < length; i++) {
        if (result === Strings_Empty) {
            result = GenerateRandomInt(0, max).toString();
        } else {
            result += GenerateRandomInt(0, max).toString();
        }
    }

    return result;
}
